/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Status of the delivery note. open = created, sent = checked-out, closed = checked-in.
 */
export enum DeliveryNoteStatus {
  Open = 'open',
  Sent = 'sent',
  Closed = 'closed'
}
